import React from "react"

import Layout from "../components/Layout"
import SEO from "../components/seo"

const SecondPage = () => (
  <Layout pageTitle="Stay Informed">
    <SEO title="Stay Informed" />
    
    <p>Sign up for our newsletter!</p>
    
  </Layout>
)

export default SecondPage
